export const uniqueKey = {
  budget: "p",
  length: "l",
  travelStyle: "s",
  experiences: "e",
  regions: "r",
  accommodation: "a",
};

export const inputPropsBudget = {
  name: "budget-filter",
};

export const budgetFilterProps = {
  initialSteps: [0, 3000],
  maxStep: 3000,
  increments: 1,
  minimumStep: 0,
  sublabel: "Per person",
  currencyPrefix: "US$",
  minLabel: "MIN",
  maxLabel: "MAX",
  inputProps: inputPropsBudget.name,
};

export const countryColorFallback = "var(--colour-orange)";
